import { DRIVERS } from '../../actions/drivers/types'
import { omit } from 'ramda'

function reducer(state = {}, action) {
  switch (action.type) {
    case DRIVERS.GET_LIST:
      return action.payload.list.reduce(
        (acc, driver) => ({
          ...acc,
          [driver.id]: driver,
        }),
        {},
      )
    case DRIVERS.ADD:
      return {
        ...state,
        [action.payload.id]: action.payload,
      }
    case DRIVERS.UPDATE:
      return {
        ...state,
        [action.payload.id]: action.payload,
      }
    case DRIVERS.REMOVE:
      return omit([action.payload], state)
    default:
      return state
  }
}

export default reducer
